import { render, staticRenderFns } from "./AutocompletePlaces.vue?vue&type=template&id=45323820&"
import script from "./AutocompletePlaces.vue?vue&type=script&lang=js&"
export * from "./AutocompletePlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports